module.exports = __webpack_public_path__ + "static/support-0bc12cba84d05c3f8854d44cf95bf052.png";